export default {
  activeContent(state, getters, rootState) {
    const productId = rootState.activeContentProductId;
    if (!productId) return null;
    return (
      state.contents.find(
        content => Number(content.product_id) === Number(productId)
      ) || null
    );
  },
  unlockedContents(state) {
    return state.contents.filter(content => content.unlock);
  },
  lockedContents(state) {
    return state.contents.filter(content => !content.unlock);
  }
};
